module.exports = __webpack_public_path__ + "img/ctyun.0d9ecd8a.svg";